module.exports = __webpack_public_path__ + "static/media/Rectangle27.62f98be8.png";